import { useState } from "react";
import Grid from "@mui/material/Grid";
import { usePut } from "../../actprep-ui/hooks/api";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { useEffect } from "react";
import CreationFormWrapper from "../../actprep-ui/components/CreationFormWrapper";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";
import ProgramDayForm from "../ProgramDayForm";
import { programDayTitles } from "../../actprep-ui/constants/program";

function getProgramDayTitle(order) {
  if (order < 0 || order > 6) {
    throw Error(`Invalid ProgramDay order: ${order}`);
  }
  return programDayTitles[order];
}

export default function SwitchProgramDayForm({
  open,
  setOpen,
  programWeek,
  order,
  onProgramDaySwitched,
}) {
  const [error, setError] = useState(null);
  const [programDay, setProgramDay] = useState(null);
  const addProgramDayToProgramWeekMutation = usePut(
    apiUrls.admin.programDayToProgramWeek()
  );

  const onSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      order: order,
      program_week_uuid: programWeek?.uuid,
      new_program_day_uuid: programDay.uuid,
    };
    const { data } = await addProgramDayToProgramWeekMutation.mutateAsync(
      payload
    );
    if (!data.success) {
      setError(data.reason);
      return;
    }
    setOpen(false);
    showSuccessSnackbar("Program Day Switched!");
    onProgramDaySwitched();
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (open) {
      setProgramDay(null);
    }
  }, [open]);
  return (
    <CreationFormWrapper
      open={open}
      onClose={handleClose}
      onSubmit={onSubmit}
      error={error}
      title={`Switch ${getProgramDayTitle(order)} on ${programWeek?.title}`}
      confirmText="Switch"
    >
      <Grid container gap={3} marginTop={1}>
        <Grid size={12}>
          <ModelAutoComplete
            modelName={"ProgramDay"}
            label={"New Program Day"}
            value={programDay}
            setValue={setProgramDay}
            allowCreation
            CreationForm={(props) => <ProgramDayForm {...props} />}
          />
        </Grid>
      </Grid>
    </CreationFormWrapper>
  );
}
